<template>
    <div>
        <el-form label-position="top" class="u-mb-10" v-if="exibeSelectInstituicao">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Instituição">
                        <el-select v-model="filtroInstituicao.id" filterable disabled placeholder="Instituição" style="width:100%">
                            <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                        </el-select>
                        <small class="u-text-muted">Para trocar de instituição, volte para a listagem.</small>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <el-form @submit.native.prevent="onSubmitEmprestimo" :model="dados" ref="dados" label-position="top">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="6" :md="6">
                    <el-form-item label="Tipo de leitor" prop="usuario_tipo" :rules="[$requiredChange]" key="usuario_tipo">
                        <el-select v-model="dados.usuario_tipo" @change="onTipoChange" style="width: 100%;">
                            <el-option label="ALUNO" value="aluno"></el-option>
                            <el-option label="SERVIDOR" value="servidor"></el-option>
                            <el-option label="FUNCIONÁRIO" value="funcionario"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="10" :md="10">
                    <el-form-item label="Leitor (busca por nome)" prop="usuario_id" :rules="[$requiredChange]" key="usuario_id">
                        <el-select
                            v-model="dados.usuario_id"
                            placeholder="Selecione o tipo e digite o nome..."
                            filterable
                            remote
                            clearable
                            :remote-method="getLeitorByFilter"
                            :loading="loadingLeitor"
                            :disabled="!dados.usuario_tipo"
                            style="width: 100%;">
                            <el-option v-for="l in leitores" :key="l.tipo + '-' + l.id" :label="l.label" :value="l.id"></el-option>
                        </el-select>
                        <small class="u-text-muted">Digite ao menos 2 caracteres do nome.</small>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="8" :md="8">
                    <el-form-item label="Exemplar" prop="exemplar_id" :rules="[$requiredBlur]" key="exemplar_id">
                        <el-select
                            v-model="dados.exemplar_id"
                            placeholder="Pesquisar exemplar..."
                            filterable
                            remote
                            :remote-method="getExemplarByFilter"
                            :loading="loadingExemplar"
                            style="width: 100%;">
                            <el-option
                                v-for="item in exemplares"
                                :key="item.id"
                                :label="formatExemplarLabel(item)"
                                :value="item.id">
                            </el-option>
                        </el-select>
                        <small class="u-text-muted">Busque por código, status ou título/autor do livro (apenas exemplares DISPONÍVEL aparecem).</small>
                    </el-form-item>
                </el-col>
            </el-row>

            <!--
                BLOCO Y — situação do leitor (item 15). Leitor suspenso não leva livro, e o
                bloqueio de verdade está no Service: aqui só se mostra o MOTIVO, para o
                operador saber o que dizer a quem está no balcão.
            -->
            <el-row :gutter="10" v-if="fichaLeitor">
                <el-col :xs="24">
                    <el-alert v-if="situacaoLeitor === 'suspenso'" type="error" show-icon :closable="false" class="u-mb-15"
                              :title="'Leitor SUSPENSO — ' + (fichaLeitor.situacao.motivo || '')"
                              :description="fichaLeitor.situacao.ate ? ('Até ' + fichaLeitor.situacao.ate) : 'Por tempo indeterminado'">
                    </el-alert>
                    <el-alert v-else-if="situacaoLeitor === 'inativo'" type="warning" show-icon :closable="false" class="u-mb-15"
                              title="Leitor sem vínculo ativo na rede"></el-alert>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :xs="24" :sm="8" :md="8">
                    <!--
                        Item 17 pede "data E HORA do empréstimo". A hora é a do registro: se a
                        data for hoje, o backend grava o momento real. Data retroativa fica sem
                        hora, e a tela mostra isso — não se inventa um horário.
                    -->
                    <el-form-item label="Data do empréstimo" prop="data_emprestimo" key="data_emprestimo">
                        <el-date-picker v-model="dados.data_emprestimo" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                        <small class="u-text-muted">
                            {{ dados.data_emprestimo === hoje ? 'A hora será a do registro.' : 'Data retroativa: sem hora registrada.' }}
                        </small>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="8" :md="8">
                    <el-form-item label="Devolução prevista" prop="data_prevista_devolucao" :rules="[$requiredChange]" key="data_prevista_devolucao">
                        <el-date-picker v-model="dados.data_prevista_devolucao" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="8" :md="8">
                    <!--
                        Item 17 — "informações do leitor, DEPENDENTE, data e hora...". Opcional:
                        o normal é o próprio leitor retirar. Só aparecem os dependentes ATIVOS
                        daquele leitor; o backend confere de novo antes de gravar.
                    -->
                    <el-form-item label="Dependente (opcional)" prop="dependente_id" key="dependente_id">
                        <el-select v-model="dados.dependente_id" placeholder="Retirada pelo próprio leitor"
                                   clearable style="width: 100%;" :disabled="!dependentes.length">
                            <el-option v-for="d in dependentes" :key="d.id"
                                       :label="(d.pessoa ? d.pessoa.nome : ('#' + d.dependente_id)) + ' — ' + (d.parentesco || '').toUpperCase()"
                                       :value="d.id"></el-option>
                        </el-select>
                        <small class="u-text-muted">
                            {{ dependentes.length ? 'Deixe em branco se o próprio leitor está retirando.' : 'Este leitor não tem dependentes vinculados.' }}
                        </small>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :xs="24">
                    <el-form-item class="u-text-right u-mt-15">
                        <el-button type="primary" id="btn-emprestimo" native-type="submit">SALVAR</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
export default {
    data: () => ({
        // BLOCO Y — ficha do leitor selecionado (situação e dependentes).
        fichaLeitor: null,
        dependentes: [],
        loadingExemplar: false,
        exemplares: [],
        loadingLeitor: false,
        leitores: [],
        filtroInstituicao: { id: '', nome: '' },
        dados: {
            usuario_tipo: '',
            usuario_id: '',
            dependente_id: '',
            exemplar_id: '',
            data_emprestimo: new Date().toISOString().slice(0,10),
            data_prevista_devolucao: ''
        }
    }),
    computed: {
        hoje(){ return new Date().toISOString().slice(0, 10); },
        situacaoLeitor(){ return this.fichaLeitor && this.fichaLeitor.situacao ? this.fichaLeitor.situacao.situacao : ''; },

        exibeSelectInstituicao(){
            const t = Number(this.$store.state.user.tipo);
            return (t > 3 && t <= 8) || t === 10;
        }
    },
    watch: {
        // Escolheu o leitor: busca situação (item 15) e dependentes (item 14).
        'dados.usuario_id'(){ this.carregarFichaDoLeitor(); }
    },
    mounted(){
        this.restaurarInstituicaoDoQuery();
        if(this.$store.state.config.instituicao){
            this.filtroInstituicao = { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome };
        }
    },
    methods:{
        /**
         * Ao escolher o leitor, busca a ficha: situação (item 15) e dependentes (item 14).
         * Falhar aqui não impede o empréstimo — o backend valida de novo, e é ele que decide.
         */
        carregarFichaDoLeitor(){
            this.fichaLeitor = null;
            this.dependentes = [];
            this.dados.dependente_id = '';

            if(!this.dados.usuario_tipo || !this.dados.usuario_id) return;

            const inst = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : null;
            const q = inst ? `?instituicao_id=${inst}` : '';

            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/biblioteca/leitor/ficha/${this.dados.usuario_tipo}/${this.dados.usuario_id}${q}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if(!r.data || r.data.erro) return;
                this.fichaLeitor = r.data;
                this.dependentes = (r.data.dependentes || []).filter(d => d.situacao);
            }).catch(() => {});
        },

        restaurarInstituicaoDoQuery(){
            const qId = this.$route.query.instituicao_id;
            if(!qId) return;
            const atual = this.$store.state.config.instituicao;
            if(atual && atual.id && String(atual.id) === String(qId)) return;
            const lista = this.$store.state.instituicoes || [];
            const fromList = Array.isArray(lista)
                ? lista.find(x => x && String(x.id) === String(qId))
                : (lista[qId] || null);
            const inst = fromList || { id: qId, nome: '' };
            this.$store.commit('setInstituicao', inst);
        },
        onTipoChange(){
            // ao trocar o tipo, limpa o leitor selecionado e o que dependia dele
            this.dados.usuario_id = '';
            this.dados.dependente_id = '';
            this.leitores = [];
            this.fichaLeitor = null;
            this.dependentes = [];
        },
        getLeitorByFilter(query){
            if(!query || query.length < 2){ this.leitores = []; return; }
            if(!this.dados.usuario_tipo){
                window.eventBus.$emit('alert', {msg: 'Selecione o tipo do leitor antes de pesquisar.', type: 'warning'});
                return;
            }
            this.loadingLeitor = true;
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/biblioteca/leitor/searchByNome`,
                { query, tipo: this.dados.usuario_tipo },
                this.$store.getters.getHeaderAuth
            ).then(response => {
                this.leitores = Array.isArray(response.data) ? response.data : [];
                this.loadingLeitor = false;
            }).catch((error) => { this.loadingLeitor = false; this.$store.commit('throwException', error); });
        },
        formatExemplarLabel(item){
            const livro = (item && item.livro) ? item.livro : null;
            const titulo = livro && livro.titulo ? livro.titulo : '';
            const autor = livro && livro.autor ? livro.autor : '';
            const status = item && item.status ? String(item.status).toUpperCase() : '';
            const codigo = item && item.codigo ? item.codigo : '';

            let label = `#${item.id} - ${codigo}`;
            if(titulo) label += ` - ${titulo}`;
            if(autor) label += ` (${autor})`;
            if(status) label += ` - ${status}`;
            return label;
        },
        getExemplarByFilter(query){
            if(!query || query.length < 2){
                this.exemplares = [];
                return;
            }

            this.loadingExemplar = true;
            const instituicaoId = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : '';

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/biblioteca/exemplar/searchByNome`, { query, instituicao_id: instituicaoId }, this.$store.getters.getHeaderAuth).then(response => {
                // mantém apenas disponíveis
                const data = response.data || [];
                this.exemplares = Array.isArray(data) ? data.filter(x => x && x.status === 'disponivel') : [];
                this.loadingExemplar = false;
            }).catch((error) => {
                this.loadingExemplar = false;
                this.$store.commit('throwException', error);
            });
        },
        onSubmitEmprestimo(){
            document.getElementById("btn-emprestimo").focus();

            this.$refs.dados.validate((valid) =>{ if(valid){
                window.eventBus.$emit('loading', true);

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/biblioteca/emprestimo/store`, this.dados, this.$store.getters.getHeaderAuth).then((response) => {
                    window.eventBus.$emit('loading', false);
                    if(response.data && response.data.erro){
                        const msg = typeof response.data.erro === 'string' ? response.data.erro : (response.data.erro.text || 'Não foi possível registrar o empréstimo.');
                        window.eventBus.$emit('alert', {msg, type: 'warning'});
                        return;
                    }
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.$emit('onSubmitEmprestimo');
                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        }
    }
}
</script>

